import { ArrowRightOutlined, StarFilled } from '@ant-design/icons';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import { useAutomations } from '../../use-automations';
import styles from './AutomationTemplate.module.css';
import { ReactComponent as FacebookIcon } from './facebook.svg';
import { ReactComponent as InstagramIcon } from './instagram.svg';

import { ReactComponent as SmartphoneIcon } from './smartphone.svg';
import {
  AUTOMATION_TEMPLATES,
  AutomationTemplateName,
  AutomationTemplateChannel,
  AutomationTemplateDefinition,
} from './Templates/TemplateDefinitions';

interface Props {
  templateName: AutomationTemplateName;
  highlight?: boolean;
  setActiveTemplate: (template: {
    template: AutomationTemplateDefinition;
    channel: AutomationTemplateChannel;
  }) => void;
  templateChannel: AutomationTemplateChannel;
  activeStep: number;
  setActiveStep: (step: number) => void;
  outboundAutomationParams?: any;
  closeModal?: () => void;
}

export const AutomationTemplate: FunctionComponent<Props> = props => {
  const {
    templateName,
    highlight,
    setActiveTemplate,
    templateChannel,
    activeStep,
    setActiveStep,
    outboundAutomationParams,
    closeModal,
  } = props;
  const template = AUTOMATION_TEMPLATES[templateName];
  const { createAutomation } = useAutomations();

  const onTemplateClick = async () => {
    if (outboundAutomationParams) {
      await createAutomation(templateName, outboundAutomationParams);
      closeModal?.();
    }
    setActiveTemplate({
      template,
      channel: templateChannel,
    });
    setActiveStep(activeStep + 1);
  };
  return (
    <div
      className={classNames(styles.container, {
        [styles.container__highlight]: highlight,
      })}
      style={highlight ? template.highlightStyle : {}}
      onClick={onTemplateClick}
    >
      <div className={styles.overlay} />

      <div className={styles.topArea}>
        <span className={styles.icon}>
          <template.icon />
        </span>
        <div>
          <div className={styles.title}>{template.title}</div>
          {!!template.subtitle && (
            <div className={styles.subtitle}>{template.subtitle}</div>
          )}
          <div className={styles.stars}>
            <StarFilled />
            <StarFilled />
            <StarFilled />
            <StarFilled />
            <StarFilled />
          </div>
        </div>
      </div>
      <div className={styles.tags}>
        {template.tags.map(tag => (
          <div key={tag.title} className={styles.tag}>
            <tag.icon />
            {tag.title}
          </div>
        ))}
      </div>
      <div className={styles.description}>{template.description}</div>
      <div className={styles.bottomRow}>
        <div className={styles.channels}>
          {template.channels.instagram && <InstagramIcon />}
          {template.channels.facebook && <FacebookIcon />}
          {template.channels.sms && <SmartphoneIcon />}
        </div>
        <div
          className={classNames(styles.button, {
            [styles.button__highlight]: highlight,
          })}
        >
          Create
          <ArrowRightOutlined />
        </div>
      </div>
    </div>
  );
};
